// extracted by mini-css-extract-plugin
export default {"tag_box":"ShiftTag_tag_box__C0O1H","text":"ShiftTag_text__jFE2v","icon":"ShiftTag_icon__rZM5v"};